import type { LogoBlockProps } from "./types";
import PanelContainer from "../../lib/panel/panel-container";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import PanelLogoSize from "./email-panel-size";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { BlockPanelProps } from "../../lib/register-block";


export function LogoEmailPanelRenderer(blockProps: BlockPanelProps<LogoBlockProps>) {
  return (
		<PanelContainer blockProps={blockProps}>
			<PanelLogoSize />
			<PanelBlockAlignment />
      <PanelTranslationState mode="not-translatable" portal/>
		</PanelContainer>
	);
}
